import React, { useEffect } from 'react';
import './Modal.scss';

const Modal = ({
    isOpen,
    onClose,
    title,
    children,
    footer,
    size = 'medium', // 'small', 'medium', 'large', 'full'
    showCloseButton = true,
    closeOnOverlayClick = true
}) => {
    // Handle ESC key to close modal
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27 && isOpen) {
                onClose();
            }
        };
        
        if (isOpen) {
            document.addEventListener('keydown', handleEsc);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }
        
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (closeOnOverlayClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            className="octopus-modal-overlay" 
            onClick={handleOverlayClick}
        >
            <div 
                className={`octopus-modal-content octopus-modal-${size}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="octopus-modal-header">
                    {title && <h3>{title}</h3>}
                    {showCloseButton && (
                        <button 
                            className="octopus-modal-close"
                            onClick={onClose}
                            aria-label="Close modal"
                        >
                            <i className="fa-solid fa-times"></i>
                        </button>
                    )}
                </div>
                
                <div className="octopus-modal-body">
                    {children}
                </div>
                
                {footer && (
                    <div className="octopus-modal-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;

